import { jobBoardApi } from './jobBoardApi';
import { ApplicantDto, ApplicationStatus, ApplyForJobRequest } from '../types/jobBoard';

export const applicantApi = {
  getApplicantsByJob: (jobId: string) => jobBoardApi.getApplicantsByJob(jobId),
  apply: (data: ApplyForJobRequest | FormData) => {
    if (data instanceof FormData) return jobBoardApi.applyForJob(data);
    const form = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) form.append(key, value instanceof File ? value : String(value));
    });
    return jobBoardApi.applyForJob(form);
  },
  updateStatus: (id: string, status: ApplicationStatus) => jobBoardApi.updateApplicantStatus(id, status),
};

export const ApplicantApi = applicantApi;
export type { ApplicantDto };